import { createStyles, makeStyles } from "@material-ui/core";

export const useStyles = makeStyles(() =>
  createStyles({
    root: {
      display: "flex",
      flexDirection: "column",
      flex: "1 1 0",
      minWidth: 0,
    },
    label: {
      marginBottom: 4,
    },
    value: {
      wordBreak: "break-word" as const,
      whiteSpace: "pre-wrap" as const,
    },
  })
);
